import { useCallback, useState } from "react";
import { AuthApi } from "../../infrastructure/api/AuthApi";
import { EnableTotpRepositoryImpl } from "../../infrastructure/repositories/EnableTotpRepositoryImpl";
import { SessionManager } from "../../infrastructure/session/SessionManager";
import { sendEmailOtp } from "../useCases/sendEmailOtp";
import { loginUser, type LoginResult } from "../useCases/loginUser";
import type { LoginDTO } from "../../domain/dto/LoginDTO";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const login = useCallback(async (data: LoginDTO): Promise<LoginResult> => {
    setLoading(true);
    setError(null);
    try {
      const repo = new AuthApi();
      const sessionPort = new SessionManager();
      const result = await loginUser(repo, sessionPort, data);

      if (
        result.nextStep === "email-verification" &&
        result.user.temp_access_token
      ) {
        const totpRepo = new EnableTotpRepositoryImpl();
        await sendEmailOtp(
          totpRepo,
          sessionPort,
          result.user.email,
          "LOGIN",
          result.user.temp_access_token,
        );
      }

      return result;
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : "Login failed. Please try again.";
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { login, loading, error };
};
